import { MockJobCategorySelect, MockJobCategorySuggest } from 'wingman-fe';

import { ThemedExample } from '#src/components/ThemedExample/ThemedExample.tsx';

export const SeekJobCategorySelect = () => (
  <ThemedExample>
    <MockJobCategorySelect
      id="seek-job-category-select"
      label="Category"
      schemeId="seekAnz"
      showStorybookAction
    />
  </ThemedExample>
);

export const SeekJobCategorySuggest = () => (
  <ThemedExample>
    <MockJobCategorySuggest
      positionProfile={{
        // Our mock isn't clever enough to vary itself on these inputs (yet).
        positionLocation: [],
        positionTitle: '',
        positionFormattedDescriptions: [],
        positionOrganizations: [],
      }}
      onSelect={() => undefined}
      schemeId="seekAnz"
      showStorybookAction
    />
  </ThemedExample>
);
